export default "__VITE_ASSET__Dacb$D8A__"